import { Component, EventEmitter, Input, Output, inject, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { InputNumberModule } from "primeng/inputnumber";
import { SelectModule } from "primeng/select";
import { Ripple } from 'primeng/ripple';
import { TranslocoModule } from '@jsverse/transloco';

import type { ModelsCompanyPosition, ModelsTemplatePosition } from "../../../app/api/model/models";
import { TemplatePositionsService } from "../../../app/api/api/templatePositions.service";
import { AuthService } from "../../../services/AuthService";

@Component({
  selector: 'app-hr-position-form',
  template: `
    <p-dialog [(visible)]="visible" [style]="{width: '450px'}" [header]="'Position Details' | transloco" [modal]="true"
              styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="field">
          <label for="name">{{ 'Name' | transloco }}</label>
          @if (!position.id) {
            <p-select
              id="name"
              appendTo="body"
              [options]="templatePositions"
              [(ngModel)]="selectedTemplatePosition"
              optionLabel="localizedName"
              [editable]="true"
              [placeholder]="'Select or type position' | transloco"
              [required]="true">
            </p-select>
          } @else {
            <input type="text" pInputText id="name" [(ngModel)]="position.name" required autofocus/>
          }
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple [label]="'Cancel' | transloco" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple [label]="'Save' | transloco" icon="pi pi-check" class="p-button-text" (click)="doSave()"></button>
      </ng-template>
    </p-dialog>
  `,
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    InputNumberModule,
    SelectModule,
    Ripple,
    TranslocoModule
  ]
})
export class HrPositionsForm implements OnInit, OnChanges {
  @Input() visible = false;
  @Input() position: ModelsCompanyPosition = {} as ModelsCompanyPosition;
  @Output() onSave = new EventEmitter<ModelsCompanyPosition>();
  @Output() onCancel = new EventEmitter<void>();

  private templatePositionsApi = inject(TemplatePositionsService);
  private auth = inject(AuthService);

  templatePositions: any[] = [];
  selectedTemplatePosition: any = null;

  ngOnInit() {
    this.templatePositionsApi.apiTemplatePositionsGet(true).subscribe((r: any) => {
      if (r.data) {
        const userLangId = this.auth.currentUser()?.language_id;
        this.templatePositions = r.data.map((tp: ModelsTemplatePosition) => {
          let localizedName = tp.name;
          if (tp.names && userLangId) {
            const match = tp.names.find(n => n.language_id === userLangId);
            if (match) localizedName = match.name;
          }
          return {
            ...tp,
            localizedName
          };
        });
        this.syncSelection();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['position'] || changes['visible']) {
      this.syncSelection();
    }
  }

  syncSelection() {
    if (this.position && this.templatePositions.length > 0) {
      if (this.position.template_position_id) {
        this.selectedTemplatePosition = this.templatePositions.find(p => p.id === this.position.template_position_id) || this.position.name;
      } else {
        this.selectedTemplatePosition = this.position.name;
      }
    }
  }

  hideDialog() {
    this.onCancel.emit();
  }

  doSave() {
    if (!this.position.id) {
      if (typeof this.selectedTemplatePosition === 'string') {
        this.position.name = this.selectedTemplatePosition;
        this.position.template_position_id = 0;
      } else if (this.selectedTemplatePosition) {
        this.position.name = this.selectedTemplatePosition.localizedName || this.selectedTemplatePosition.name;
        this.position.template_position_id = this.selectedTemplatePosition.id;
      }
    }
    this.onSave.emit(this.position);
  }
}
